<script>
import ContactForm from '../../components/contactForm.vue';

export default {
    name: "newsDetail",
    data() {
        return {
            detail: {}
        };
    },
    computed: {},
    components: {
        ContactForm
    },
    mounted() {
        this.$store.dispatch('getNewsDetail', {
            id: this.$route.query.id
        }).then((result) => {
            if (result.code == 100) {
                this.detail = result.data;
            }
        }).catch((err) => {
            
        });
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="news_detail">
        <div class="layout_body">
            <!-- banner -->
            <div class="banner">
                <div class="layout_bg bg" :style="`background-image: url(${detail.banner});`"></div>
            </div>
            <div class="layout_main">
                <div class="layout_content wrapper">
                    <div class="breadcrumb only_pc"><router-link to="/news">新闻</router-link> / {{ detail.category_name }}</div>
                    <div class="title">{{ detail.name }}</div>
                    <div class="content" v-html="detail.content"></div>
                    <div class="flex justify_end"><router-link class="btn" to="/news">返回</router-link></div>
                </div>
            </div>
        </div>
        <ContactForm/>
    </div>
</template>

<style scoped lang="scss">
.banner{
    width: 100%;
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    // padding: .3rem 0 .6rem;
    margin-bottom: .3rem;
}
.wrapper{
    @media only screen and (max-width: 750px) {
        padding: .4rem 0;
    }
}
.title{
    font-size: .26rem;
    text-align: center;
    margin-bottom: .3rem;
    @media only screen and (max-width: 750px) {
        font-size: .36rem;
    }
}
.content{
    font-size: .22rem;
    line-height: 1.6;
    /deep/{
        img{
            display: inline-block !important;
        }
    }
    @media only screen and (max-width: 750px) {
        font-size: .28rem;
    }
}
.btn{
    font-size: .22rem;
    margin-top: .2rem;
    cursor: pointer;
    border-bottom: 1px solid var(--font_color);
    @media only screen and (max-width: 750px) {
        font-size: .28rem;
        width: 1.2rem;
        margin: .5rem auto 0;
        border: 1px solid #333;
        height: .6rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>